module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.731a28a4.ttf";